import api from "../store/services/api";

export const getComplements = (params) => api.get("/complements/", { params });

export const createComplement = (product) =>
  api.post("/products/", product, {
    headers: { "Content-Type": "application/json" },
  });

export const editComplement = (product, productId) =>
  api.put(`/products/?pid=${productId}`, product, {
    headers: { "Content-Type": "application/json" },
  });

export const deleteComplement = (productId) =>
  api.delete(`/products/?pid=${productId}`);

const ComplementsService = {
  getComplements,
  createComplement,
  editComplement,
  deleteComplement,
};

export default ComplementsService;
